import {Button, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Stack, TextField} from "@mui/material";

export interface RecordLogFilterState {
    query: string
    accessType: string
    from: string
    to: string
}

export const emptyRecordLogFilters: RecordLogFilterState = {query: "", accessType: "", from: "", to: ""}

const accessTypes = [
    {key: "Record Search", label: "Record Search"},
    {key: "Infraction View", label: "Infraction View"},
    {key: "Notes View", label: "Notes View"},
    {key: "Complaints View", label: "Complaints View"},
    {key: "Inbox View", label: "Inbox View"},
    {key: "Inbox Open", label: "Inbox Open"},
]

export function buildRecordLogSearchUrl(filters: RecordLogFilterState, page: number): string {
    const params = new URLSearchParams()
    params.set("page", String(page))
    if (filters.query) params.set("query", filters.query)
    if (filters.accessType) params.set("accessType", filters.accessType)
    if (filters.from) params.set("from", new Date(filters.from).toISOString())
    if (filters.to) {
        const to = new Date(filters.to)
        to.setHours(23, 59, 59, 999)
        params.set("to", to.toISOString())
    }
    return `/api/records/logs/search?${params.toString()}`
}

export function isRecordLogFiltering(filters: RecordLogFilterState): boolean {
    return filters.query !== "" || filters.accessType !== "" || filters.from !== "" || filters.to !== ""
}

interface RecordLogFilterPanelProps {
    filters: RecordLogFilterState
    onChange: (f: RecordLogFilterState) => void
    onClear: () => void
}

export function RecordLogFilterPanel({filters, onChange, onClear}: RecordLogFilterPanelProps) {
    return <Stack direction="row" spacing={1} alignItems="center" sx={{flexWrap: "wrap", gap: 1}}>
        <TextField
            label="Search supervisor / employee / reason"
            variant="outlined"
            size="small"
            sx={{minWidth: {xs: "100%", sm: 260}}}
            value={filters.query}
            onChange={e => onChange({...filters, query: e.target.value})}
        />
        <FormControl size="small" sx={{minWidth: {xs: "100%", sm: 180}}}>
            <InputLabel>Action Type</InputLabel>
            <Select
                value={filters.accessType}
                label="Action Type"
                onChange={(e: SelectChangeEvent) => onChange({...filters, accessType: e.target.value})}
            >
                <MenuItem value=""><em>Any</em></MenuItem>
                {accessTypes.map(t => <MenuItem key={t.key} value={t.key}>{t.label}</MenuItem>)}
            </Select>
        </FormControl>
        <TextField
            label="From"
            type="date"
            size="small"
            InputLabelProps={{shrink: true}}
            sx={{minWidth: {xs: "calc(50% - 4px)", sm: "auto"}}}
            value={filters.from}
            onChange={e => onChange({...filters, from: e.target.value})}
        />
        <TextField
            label="To"
            type="date"
            size="small"
            InputLabelProps={{shrink: true}}
            sx={{minWidth: {xs: "calc(50% - 4px)", sm: "auto"}}}
            value={filters.to}
            onChange={e => onChange({...filters, to: e.target.value})}
        />
        {isRecordLogFiltering(filters) &&
            <Button size="small" color="warning" onClick={onClear}>Clear</Button>
        }
    </Stack>
}
